import React from "react";
import PropTypes from "prop-types";
import Button from "components/atoms/Button";
import classnames from "classnames";
import Icon from "components/atoms/Icon";

const FilterBox = ({
  onCloseClick,
  className,
  render,
  renderName,
  hasBoxShadow,
}) => {
  const componentClassName = "sal-filter-box";
  const classNames = classnames(className, componentClassName, {
    [`${componentClassName}--has-box-shadow`]: hasBoxShadow,
  });
  const renderClass = classnames(componentClassName + "__content", {
    [`${componentClassName}__${renderName}`]: renderName,
  });

  return (
    <div className={classNames}>
      <div className={componentClassName + "__arrow-up"} />
      {render({ className: renderClass, parentClass: componentClassName })}

      {
        <div className={componentClassName + "__footer"}>
          <Button
            name="filter"
            className={componentClassName + "__cta-button"}
            value="filter"
            onClick={onCloseClick}
            styleType="secondary"
          >
            <Icon
              type="Schliessen"
              className={componentClassName + "__icon-remove"}
            />
            Schließen
          </Button>
        </div>
      }
    </div>
  );
};

FilterBox.propTypes = {
  className: PropTypes.string,
  selectedValues: PropTypes.array,
  currentValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCloseClick: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  renderName: PropTypes.string,
  hasBoxShadow: PropTypes.bool,
};

export default FilterBox;
